import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Affix } from "antd";
import * as actions from './redux/actions';

import ExamHead from "./ExamHead";
import ExamPagePane from "./ExamPagePane";
import SettingPane from "./SettingPane";
import CountDown from "./CountDown"
import Sheet from "./Sheet"
export class Exam extends Component {
  static propTypes = {
    quesStore: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentWillMount() {
    let { name, id } = this.props.match.params;
    if (name === 'page') {
      this.props.actions.fetchGetExamDetail({ examPaperId: id })
    } else if (name === 'check') {
      let resultId = id.split('-')[1];
      let examPaperId = id.split('-')[0];
      this.props.actions.fetchGetExamPageResult({ busId: examPaperId, resultId });
      this.props.actions.updateCheckAllPars({ payload: true });
    } else if (name === 'continue') {
      let resultId = id.split('-')[1];
      let examPaperId = id.split('-')[0];
      this.props.actions.fetchGetExamPageResult({ busId: examPaperId, resultId });
    }
  }
  componentWillUnmount() {
    this.props.actions.updateCheckAllPars({ payload: false });
  }
  render() {
    return (
      <div className="ques-store-exam">
        <ExamHead />
        <div className="panes">
          <div className="left">
            <ExamPagePane />
          </div>
          <div className="right">
            <SettingPane />
            <Affix offsetTop={30}>
              <CountDown />
              <Sheet ExamModel={2} />
            </Affix>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    quesStore: state.quesStore,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Exam);



// WEBPACK FOOTER //
// ./src/features/ques-store/Exam.js